import './faq';
import './faq-page';
import './form-labels';
import './team-slider';
import './cat';
import './lazy-loading';
import './menu';